import React from "react";
import SiteDocumentation from "./SiteDocumentation";

export default function XMQ_doc_data_integration() {
    return <SiteDocumentation page="data-integration"/>;
}
